<template>
    <Routelist v-if="routes.length"
        :routes="routes"
        :favourites="favouritesMap"
        :registrations="{}"
        :current-user="props.personId"
        @toggle-favourite="remove"
    />
    <p v-else-if="loaded" class="routelist__empty">Du har ikke lagret noen favoritter</p>

</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Routelist from './Routelist.vue';

const props = defineProps({
    csrfToken: { type: String, required: true },
    personId: { type: Number, required: true },
});

const routes = ref([]);
// Gates the empty-state message so it doesn't flash before the fetch below
// resolves - only meaningful once we actually know the list is empty.
const loaded = ref(false);

onMounted(async () => {
    try {
        const response = await fetch('/xhr/frontend/users/favourites', {
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            return;
        }
        const data = await response.json();
        routes.value = data.favourites || [];
    } catch (e) {
        // Leave the list empty.
    } finally {
        loaded.value = true;
    }
});

// Every route here is already a favourite - drives Routelist's heart-filled
// styling the same way /turer's own favourites map does.
const favouritesMap = computed(() =>
    Object.fromEntries(routes.value.map((route) => [route.page_id, 1]))
);

// Routelist.vue only emits intent - the actual POST (reusing the same
// endpoint /turer's heart uses) lives here, this tree's root. Every route
// shown here is already a favourite, so toggling always removes it.
async function remove(route) {
    routes.value = routes.value.filter((r) => r.page_id !== route.page_id);

    try {
        await fetch('/xhr/frontend/users/favourites/' + route.page_id, {
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': props.csrfToken },
        });
    } catch (e) {
        // Already removed from the list - a failed request just means it'll
        // still show as a favourite next time the page loads.
    }
}
</script>
